export default __webpack_public_path__ + "static/media/payment-plan-deposit-three.ce8c6508.png";